module.exports = __webpack_public_path__ + "static/media/ALJ-intro.5b465064.mp4";